// A slim bar under the flow header, from the quote screen onward, offering
// a way to keep the quote in an account. It routes to the account station
// and can be dismissed for the session.

import { XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

import { LINK_BUTTON_CLASS } from "components/FlowButtons";

import { stationPath } from "./step-routes";

export default function SaveQuoteBar({
  quoteId,
  onDismiss,
}: {
  quoteId: string;
  onDismiss: () => void;
}) {
  return (
    <div
      role="region"
      aria-label="Save your quote"
      className="border-b border-oat-200 bg-white px-4 py-2.5 2xs:px-5 sm:px-10"
    >
      <div className="mx-auto flex w-full max-w-[1180px] items-center justify-between gap-3">
        <p className="text-sm text-soil sm:text-base">
          <span className="font-bold">Save your quote.</span>{" "}
          <span className="hidden text-oat-700 sm:inline">
            Create a free account to come back to it from any device.
          </span>
        </p>
        <div className="flex flex-none items-center gap-3">
          <Link
            to={stationPath(quoteId, "account")}
            className={`${LINK_BUTTON_CLASS} text-sm sm:text-base`}
          >
            Save it
          </Link>
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Dismiss"
            className="rounded-md p-1 text-oat-700 transition-colors hover:text-soil"
          >
            <XMarkIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
